(function () {
    'use strict';
    EO_TimePickerController.$inject = ['$scope', '$attrs', '$element'];

    function EO_TimePickerController($scope, $attrs, $element) {
//
        var $ctrl = this;


        // Model bound to input fields and modal
        $ctrl.label = 'ساعت';
        $ctrl.time = new Date();
        $ctrl.selectableTimes = [];
        $ctrl.selectedTime = {};

        // Optional message to display below each input field
        /*   $ctrl.message = {
               hour: 'Hour is required',
               minute: 'Minute is required',
               meridiem: 'Meridiem is required'
           }

           $ctrl.readonly = false;

           $ctrl.required = true;*/


        $ctrl.init_momentTime = "";
        $ctrl.minMomentTime = "00:00";
        $ctrl.momentTime = $ctrl.init_momentTime;
        $ctrl.timeIsSet = false;
        $ctrl.inited = false;
        $ctrl.selectedTimeChanged = selectedTimeChanged;
        fillSelectableTimes();
        $scope.$watch('$ctrl.momentTime', function (momentTime) {

            if (momentTime && $ctrl.momentTime != $ctrl.init_momentTime) {
                var hour = momentTime.split(":")[0].trim();
                var min = momentTime.split(":")[1].trim();
                $ctrl.timeValue = new Date(1970, 0, 1, hour, min, 0);
                if ($ctrl.selectedTime)
                    $ctrl.timeValue = $ctrl.selectedTime;


            }
        });

        $scope.$watch('$ctrl.timeValue', function (timeValue) {

            if (timeValue && (!$ctrl.inited || ($ctrl.inited && $ctrl.lock) || $ctrl.canSetFromOutSide)) {
                setTime(timeValue);
                $ctrl.inited = true;
                $ctrl.selectedTime = timeValue;
                setSelectedTime();

            }
        });
        $scope.$watch('$ctrl.minValue', function (timeValue) {

            if (timeValue) {
                setMinTime(timeValue)
                fillSelectableTimes();


            }
        });

        // $scope.$on('time-range-set-time', function(event, timeValue) {
        //     // profileObj contains; name, country and email from emitted event
        //     $ctrl.timeValue = timeValue;
        //     setTime(timeValue);
        //     $ctrl.selectedTime=timeValue;
        //     setSelectedTime();
        // });

        function selectedTimeChanged() {
            if ($ctrl.selectedTime)
                $ctrl.timeValue = $ctrl.selectedTime;
        }

        function setSelectedTime() {
            if ($ctrl.selectedTime) {
                var temp = new Date($ctrl.selectedTime);
                angular.forEach($ctrl.selectableTimes, function (to) {
                    if (to.value.getHours() == temp.getHours() && to.value.getMinutes() == temp.getMinutes()) {
                        to.value = $ctrl.selectedTime;
                        to.selected = true;
                    }

                })
            }
        }

        function fillSelectableTimes() {
            var startMinute = 0;
            var startHour = 0;
            var stepper = 5;
            $ctrl.selectableTimes = [];
            for (var h = startHour; h < 24; h++) {
                for (var m = startMinute; m < 60; m = m + stepper) {
                    var time = makeTimeObject(h, m);
                    if (isInRange(time))
                        $ctrl.selectableTimes.push(time);

                }

            }
            $ctrl.selectableTimes.push(makeTimeObject(23, 59));
            setSelectedTime();

        }

        function isInRange(t) {

            var isInRange = true;
            if ($ctrl.minValue) {
                var min = new Date($ctrl.minValue);
                var temp = new Date(t.value);
                if (temp.getHours() > min.getHours()) {

                } else if (temp.getHours() == min.getHours()) {
                    if (temp.getMinutes() <= min.getMinutes()) {
                        isInRange = false;
                    }
                } else {

                    isInRange = false;
                }
            }
            return isInRange;

        }

        function makeTimeObject(h, m) {
            var value = new Date(1970, 0, 1, h, m, 0);
            var title = 'ق.ظ';
            if (h > 12)
                title = 'ب.ظ';
            title = "  " + title + "  ";
            if (h < 10)
                h = "0" + h;
            if (m < 10)
                m = "0" + m;
            var text = " " + m + " : " + h;
            return {value: value, text: text, title: title};
        }

        var setTime = function (timeValue) {
            if (timeValue) {
                //  console.log(timeValue);
                var temp = new Date(timeValue);
                if (temp != 'Invalid Date') {
                    $ctrl.momentTime = temp.getHours() + ":" + temp.getMinutes();
                }


            }
        }
        var setMinTime = function (timeValue) {
            if (timeValue) {
                //  console.log(timeValue);
                var temp = new Date(timeValue);
                if (temp != 'Invalid Date') {
                    $ctrl.minMomentTime = temp.getHours() + ":" + temp.getMinutes();
                }

            }
        }


    }


    var EO_TimePicker = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/time-picker/eyeson.time-picker.template.html',
        controller: EO_TimePickerController,
        bindings: {
            timeValue: '=',
            id: '<',
            'minValue': '<',
            'label': '<',
            lock: '=?',
            canSetFromOutSide: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('eoTimePicker', EO_TimePicker)


})();

